module.exports = __webpack_public_path__ + "static/img/block2_5.66a325d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/parkDescription/block2_5.png
// module id = q80S
// module chunks = 1